// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__fRctT","mobile":"style_mobile__ui-8z","laptop":"style_laptop__GxoIa","v3":"style_v3__s76eG"};